
<template>
    <div v-if="evalModal" class="eval-modal">
        <div @click.stop class="inner">
            <img class="bg" src="https://s1.huishoubao.com/static/pc/common/img/eval_popup.png" alt="">
            <img class="close" @click="evalModal=false" src="https://s1.huishoubao.com/static/pc/common/img/eval_close.png" />
            <img class="pic" :src="eqcodePic" alt="">
        </div>
    </div>
</template>

<script>
import { Toast } from 'mint-ui';
import {
  buildCode
} from '@/apis/base';
export default {
  data () {
    return {
      evalModal: true,
      eqcodePic: ''
    };
  },
  computed: {
    pid () {
      return this.$route.query.pid || '1001';
    },
    productid () {
      return this.$route.params.productId;
    }
  },
  async mounted () {
    this.buildCode();
  },
  methods: {
    async buildCode () {
      try {
        let ret = await buildCode({
          sceneStr: `type|8011$pid|${this.pid}$itemid|${this.productid}`
        });
        if (+ret._errCode === 0) {
          if (ret._data.url) {
            this.eqcodePic = ret._data.url;
          } else {
            Toast('生成二维码失败，请重试!');
          }
        } else {
          Toast(ret._errStr);
        }
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>

<style lang="postcss" scoped>
    .eval-modal {
        z-index: 99;
        width: 100%;
        height: 100%;
        position: fixed;
        top: 0;
        left: 0;
        background: rgba(0,0,0,.7);
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .eval-modal .inner{
        width: 281px;
        height: 388px;
        position: relative;
    }
    .eval-modal .inner img{
        width: 100%;
        height: 100%;
        -webkit-user-select: none;
        -moz-user-select: none;
        -khtml-user-select: none;
        -ms-user-select: none;
        -o-user-select: none;
        user-select: none;
    }
    .eval-modal .inner .pic{
      position: absolute;
      width: 200px;
      height: 200px;
      bottom: 30px;
      left: 50%;
      transform: translateX(-50%);
    }
    .eval-modal .inner .close{
      position: absolute;
      width: 35px;
      height: 35px;
      bottom: -60px;
      left: 50%;
      transform: translateX(-50%);
    }
</style>



// WEBPACK FOOTER //
// src/projects/hsbpc/views/productInfo/eval-modal.vue